import React, { useEffect, useState } from "react";
import "../css/dashboard.css";
import "../css/client.css";
import { Box, Button, Menu, MenuItem, Modal } from "@mui/material";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import SearchBarMobile from "../component/SearchBarMobile";
import ClientsTabMobile from "../component/ClientsTabMobile";
import AddClientMobile from "../component/forms/AddClientMobile";
import { useAuth } from "../contexts/AuthContext";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { roles } from "../firebase.collection";
import AddQuickNoteWithClientsMobile from "../component/Notes/AddQuickNoteWithClientsMobile";
import { Add } from "@mui/icons-material";
import NotesAddModal from "../component/modals/NotesAddModal";
import { incrementDailyReads } from "../logsComponents/incrementDailyReads";

export default function ClientsContentMobile({
  filterByTherapist = false,
  title = "Clients",
  rehabFilter = null,
  initialTab = null,
}) {
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";
  const [userRole, setUserRole] = useState("");
  const [userDisplayName, setUserDisplayName] = useState("");
  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: 600,
    backgroundColor: "white",
    boxShadow: 24,
    borderRadius: 10,
  };

  const styleModalQuickNote = {
    ...styleModalGeneral, // Vous pouvez réutiliser le style de la modal générale
  };

  const [openAddClient, setOpenAddClient] = useState(false);
  const [openAddQuickNote, setOpenAddQuickNote] = useState(false);

  const handleOpenAddClient = () => setOpenAddClient(true);
  const handleCloseAddClient = () => setOpenAddClient(false);

  const handleCloseAddQuickNote = () => setOpenAddQuickNote(false);

  const [anchorElNoteType, setAnchorElNoteType] = useState(null);
  const openNoteTypeMenu = Boolean(anchorElNoteType);
  const [openAddModal2, setOpenAddModal2] = useState(false);

  const [currentNoteType, setCurrentNoteType] = useState("");

  const formatNoteType = (noteType) => {
    return noteType
      .replace(/([A-Z])/g, " $1") // Ajouter un espace avant chaque lettre majuscule
      .replace(/^./, (str) => str.toUpperCase()); // Mettre la première lettre en majuscule
  };

  const handleSelectNoteType = (noteType) => {
    setCurrentNoteType(noteType);
    setOpenAddModal2(true);
    handleCloseNoteTypeMenu();
  };

  const handleOpenNoteTypeMenu = (event) => {
    setAnchorElNoteType(event.currentTarget);
  };

  const handleCloseNoteTypeMenu = () => {
    setAnchorElNoteType(null);
  };

  const fixedNoteTypes = [
    "aftercareNote",
    "medicalNote",
    "quickNote",
    "familyNote",
    "supportStaffNote",
    "therapyNote",
    "handoverNote",
    "groupNote",
    "endOfShift",
  ];

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        try { incrementDailyReads("roles", 1); } catch {}
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const data = doc.data();
          const role = data.role;
          setUserRole(role);
          setUserDisplayName(data.displayName || "");
        } else {
          console.log("No role for this user");
        }
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const therapistFilter =
    filterByTherapist &&
    (userRole === "Therapist" || userRole === "Super Admin")
      ? userDisplayName || currentUser?.displayName || currentUser?.email || ""
      : null;

  return (
    <div className="right-container-mobile">
      <NotesAddModal
        open={openAddModal2}
        onClose={() => setOpenAddModal2(false)}
        // onClose={handleCloseAddNoteModal}
        noteType={currentNoteType}
        // handleSave={handleSaveNote}
        isMobile={true}
      />
      <Modal
        open={openAddClient}
        onClose={handleCloseAddClient}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClientMobile closemodal={handleCloseAddClient} />
        </Box>
      </Modal>
      <Modal
        open={openAddQuickNote}
        onClose={handleCloseAddQuickNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalQuickNote}>
          <AddQuickNoteWithClientsMobile closemodal={handleCloseAddQuickNote} />
        </Box>
      </Modal>
      <TopTitleBannerMobile title={title} />

      <div className="top-component-list-clients-mobile">
        {" "}
        <div style={{ width: "100%", paddingLeft: "20px" }}>
          <SearchBarMobile />
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          {(userRole === "Super Admin" || userRole === "Admission staff") && (
            // userRole === "Support Staff" ||
            // userRole === "Clinical Director" ||
            // userRole === "Admin" ||
            // userRole === "Medical Staff" ||
            // userRole === "Therapist"
            <>
              <Button
                startIcon={<Add />}
                style={{
                  width: "150px",
                  height: "45px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
                onClick={handleOpenAddClient}
                variant="outlined"
              >
                Add Client
              </Button>
              <Button
                startIcon={<Add />}
                style={{
                  width: "150px",
                  height: "45px",
                  marginRight: "20px",
                }}
                onClick={handleOpenNoteTypeMenu}
                // onClick={handleOpenAddQuickNote}
                variant="outlined"
              >
                Add Note
              </Button>
              <Menu
                anchorEl={anchorElNoteType}
                open={openNoteTypeMenu}
                onClose={handleCloseNoteTypeMenu}
              >
                {/* {noteTypes.map((noteType) => ( */}
                {fixedNoteTypes.map((noteType) => (
                  <MenuItem
                    key={noteType}
                    onClick={() => handleSelectNoteType(noteType)}
                  >
                    {formatNoteType(noteType)}
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
        </div>
      </div>
      <ClientsTabMobile
        userRole={userRole}
        therapistFilter={therapistFilter}
        rehabFilter={rehabFilter}
        initialTab={initialTab}
      />
    </div>
  );
}
